import pxToRem from "hooks/usePxToRem";

import {Grid} from "@mui/system";

import {DefaultCardStructure} from "components";
import {ModalityPayment, TypeKnowledge} from "util/globalEnums";
import {Controller, useFieldArray, useFormContext} from "react-hook-form";
import useOriginalOrAlternativeValue from "hooks/useOriginalOrAlternativeValue";
import ProcessTextField from "views/ProcessDetails/refactor/components/ProcessTextField";
import {Process} from "views/ProcessDetails/refactor/types/process.types";
import {getProcessLabel} from "views/ProcessDetails/refactor/utils/processLabels";
import ProcessSelect from "views/ProcessDetails/refactor/components/ProcessSelect";

const HouseInfoIA = () => {
  const {control, setValue, getValues} = useFormContext<Process>();

  //se tiver um tk house, pega o primeiro
  //se nao, pega o primeiro diferente de master

  /**
   * Se o house exite, retorna o index dele.
   * Se o house não existe, retorna o index do primeiro diferente de master.
   * Se o master não existe, retorna 1.
   */
  const getIndexOfHouse = () => {
    const indexOfHouse = getValues("knowledges")?.findIndex(
      (knowledge) => knowledge.typeKnowledge === "House",
    );
    const indexOfMaster = getValues("knowledges")?.findIndex(
      (knowledge) => knowledge.typeKnowledge === "Master",
    );

    if (indexOfMaster < 0) {
      return 1;
    }

    if (indexOfHouse < 0) {
      return getValues("knowledges")?.findIndex(
        (knowledge) => knowledge.typeKnowledge !== "Master",
      );
    }
    return indexOfHouse;
  };

  /**
   * Caso o house não exista, o indexOfHouse será 1.
   */
  const houseIndex = getIndexOfHouse();

  const {fields: houseBl} = useFieldArray({
    control,
    keyName: "formId",
    name: "knowledges",
  });

  const {valueOrEmptyString} = useOriginalOrAlternativeValue();

  return (
    <DefaultCardStructure
      title={getProcessLabel("knowledge.house.title", getValues("modality"))}
      hasDivider={false}
      isSubcard
    >
      {[houseBl[houseIndex]].map((house) => {
        return (
          <Grid
            container
            rowSpacing={pxToRem(20)}
            columnSpacing={pxToRem(8)}
            key={`${house.formId}`}
            sx={{mb: pxToRem(8)}}
          >
            <Grid size={6}>
              <Controller
                name={`knowledges.${houseIndex}.number` as const}
                control={control}
                render={({field: {value}}) => (
                  <ProcessTextField
                    fullWidth
                    label={getProcessLabel(
                      "knowledge.house.number",
                      getValues("modality"),
                    )}
                    size="small"
                    placeholder={getProcessLabel(
                      "knowledge.house.number",
                      getValues("modality"),
                    )}
                    name={`knowledges.${houseIndex}.number`}
                    value={valueOrEmptyString(value ?? "")}
                    onChange={(e) => {
                      setValue(
                        `knowledges.${houseIndex}.number`,
                        e.target.value,
                        {
                          shouldDirty: true,
                        },
                      );
                      setValue(
                        `knowledges[${houseIndex}].typeKnowledge` as `knowledges.0.typeKnowledge`,
                        TypeKnowledge.House,
                        {
                          shouldDirty: true,
                        },
                      );
                    }}
                  />
                )}
              />
            </Grid>
            <Grid size={6}>
              <Controller
                name={`knowledges.${houseIndex}.paymentMethod`}
                control={control}
                render={({field: {onChange, value}}) => (
                  <ProcessSelect
                    name={`knowledges.${houseIndex}.paymentMethod`}
                    value={valueOrEmptyString(value ?? "")}
                    onChange={onChange}
                    data={Object.values(ModalityPayment)}
                    size="small"
                    disabled
                    fullWidth
                    label="Modelo De Pagamento"
                  />
                )}
              />
            </Grid>
          </Grid>
        );
      })}
    </DefaultCardStructure>
  );
};

export default HouseInfoIA;
